export const demoMeetings = [{
    "conversationId": "5712338129780736",
    // "callStage": "qualification",
    
    "callScore": {
        "score": 75,
        "summary": "The representative performed well in some areas, such as communication and engagement, and question handling. However, there is room for improvement in forward motion and sales process.",
        "criteria": [
            {
                "name": "Communication and Engagement",
                "score": 80,
                "summary": "The representative greeted the prospect at the beginning and end of the call, maintained a balanced talk time, and matched the prospect's pace. However, the agenda was not explicitly mentioned in the first 5 minutes, and there were a few interruptions.",
                "feedback": {
                    "positive": {
                        "summary": "The representative greeted the prospect at the beginning and end of the call, maintained a balanced talk time, and matched the prospect's pace."
                    },
                    "negative": {
                        "summary": "The agenda was not explicitly mentioned in the first 5 minutes, and there were a few interruptions."
                    }
                }
            },
            {
                "name": "Question Handling",
                "score": 85,
                "summary": "The representative answered most of the prospect's questions and handled objections well.",
                "feedback": {
                    "positive": {
                        "summary": "The representative answered most of the prospect's questions and handled objections well."
                    },
                    "negative": {
                        "summary": "There were a few unanswered questions, but overall the representative performed well in this area."
                    }
                }
            },
            {
                "name": "Forward Motion",
                "score": 70,
                "summary": "The representative called out the next steps of the conversation but could have created better alignment with the prospect.",
                "feedback": {
                    "positive": {
                        "summary": "The representative called out the next steps of the conversation."
                    },
                    "negative": {
                        "summary": "The representative could have created better alignment with the prospect."
                    }
                }
            },
            {
                "name": "Sales Process",
                "score": 65,
                "summary": "The representative did not ask questions regarding budget, authority, need, timeline, or challenges in making a decision.",
                "feedback": {
                    "positive": {
                        "summary": "N/A"
                    },
                    "negative": {
                        "summary": "The representative did not ask questions regarding budget, authority, need, timeline, or challenges in making a decision."
                    }
                }
            }
        ]
    },
    "meetingName": "162 Test Check",
    "prospectName": "Text API File LLC",
    "startTime": new Date().toISOString(),
    "duration": "0:04:59",
    "conversationType": "sales",
    "attendees": [
        {
            "email": "symbltester1@symbl.ai",
            "id": "8a17e242-4887-41e9-b761-00b7481bafe0",
            "name": "Symbl Tester 1"
        },
        {
            "email": "symbltester2@symbl.ai",
            "id": "66786745-4ed5-4afd-9671-cd28575be514",
            "name": "Symbl Tester 2"
        },
        {
            "email": "wick@prospect.com",
            "id": "72f05da7-e0c2-42c0-bba4-6a4a1d42b748",
            "name": "Prospect Wick"
        },
        {
            "email": "john.doe@agent.com",
            "id": "f18ba00d-f7ed-4ea0-9d22-0c4f91aa4930",
            "name": "Agent John"
        }
    ],
    "callSummary": {
        "executiveSummary": "The call transcript involves a live demo of a platform that detects insights, provides real-time transcription, and generates topics of discussion. The participants discuss issues, appointments, and documents. They express excitement and interest in learning about different companies' struggles and obstacles. The prospect seeks to understand the gap between current trackers and potential advancements in technology. The conversation revolves around making processes faster and smarter. The agent promises to gather feedback and provide an update the next day. The call ends with gratitude and anticipation for further discussion.",
        "longSummary": {
            "bulletPoints": [
                "Live demo of the platform's real-time transcription and insight detection",
                "Email with generated topics of discussion to be sent after the call",
                "John will send the document by today",
                "Appointment scheduled for tomorrow evening to review the documents",
                "Discussion about going to Canada",
                "Request for a website to view details",
                "Quotation requested to share with family",
                "Mutual conversation about making the process faster or smarter",
                "Feedback to be provided tomorrow evening",
                "Thanks for the call, talk soon"
            ],
            "sentences": "This is a live demo of the platform's real-time transcription and insight detection. After the call, an email will be sent with generated topics of discussion. John will send the document by today. An appointment is scheduled for tomorrow evening to review the documents. There is a discussion about going to Canada. A request is made for a website to view details. A quotation is requested to share with family. There will be a mutual conversation about making the process faster or smarter. Feedback will be provided tomorrow evening. Thanks for the call, talk soon."
        },
        "mediumSummary": {
            "bulletPoints": [
                "Live demo of platform's capabilities",
                "Real-time transcription and topic detection",
                "Email with generated insights",
                "John will send document today",
                "Appointment set for tomorrow",
                "Request for quotation on email",
                "Mutual conversation about process improvement"
            ],
            "paragraphs": "Live demo of platform's capabilities: In this call, the Symbl Tester 1 and Symbl Tester 2 discuss a live demo of the platform. They mention that the platform can detect various insights, provide real-time transcription, and generate topics of discussion after the call. They also mention that an email will be sent with the generated insights. John will send a document by today, and an appointment is set for tomorrow to go over the provided documents. Symbl Tester 1 requests a quotation on email to discuss with other family members. The call ends with a mutual conversation about how to make the process faster or smarter."
        },
        "smallSummary": {
            "bulletPoints": [
                "Live demo of platform features including real-time transcription and topic detection",
                "John will send the document today",
                "Discussion about upcoming plans and appointment for tomorrow",
                "Prospect Wick interested in understanding obstacles in current technology",
                "Agent John will follow up tomorrow evening"
            ],
            "paragraphs": "The call was a live demo showcasing the platform's ability to provide real-time transcription and detect various topics of discussion. John confirmed that he will send the document today. There was also a discussion about upcoming plans and an appointment was set for tomorrow. Prospect Wick expressed interest in understanding the obstacles in current technology. Agent John agreed to follow up tomorrow evening."
        }
    },
    "callSentiment": {
        "chunks": [
            {
                "endTime": "00:02:00,000",
                "polarityScore": "0",
                "sentiment": "Neutral",
                "startTime": "00:00:00,000",
                "summary": "The conversation started with discussing a live demo and document updates. The participants also talked about scheduling appointments."
            },
            {
                "endTime": "00:04:00,000",
                "polarityScore": "0",
                "sentiment": "Neutral",
                "startTime": "00:02:00,000",
                "summary": "The discussion continued with questions about a website and sharing quotations. The conversation remained neutral."
            },
            {
                "endTime": "00:05:01,920",
                "polarityScore": "0.5",
                "sentiment": "Positive",
                "startTime": "00:04:00,000",
                "summary": "The call ended on a positive note with the prospect expressing gratitude and looking forward to future discussions."
            }
        ],
        "overallSentiment": "Neutral",
        "summary": "The call discussed a live demo, document updates, and scheduling appointments. The conversation was mostly neutral with some positive moments."
    },
    "callQuestionAndAnswers": {
        "questionAnswers": [
            {
                "answer": "So this is a live demo that we are trying to give very we are going to show how the platform detects various insights can do transcription in real time and also the different topics of discussions, which would be generated after the call is over, and they will be an email that will be sent to the inbox.",
                "answerBy": "Symbl Tester 1",
                "answerTime": "00:00:03,840",
                "question": "Hi Symbl, any updates on that document?",
                "questionBy": "Symbl Tester 2",
                "questionTime": "00:00:00,000"
            },
            {
                "answer": "I will come tomorrow.",
                "answerBy": "Symbl Tester 1",
                "answerTime": "00:00:52,320",
                "question": "How are you?",
                "questionBy": "Symbl Tester 2",
                "questionTime": "00:00:43,680"
            },
            {
                "answer": "I will set up a time and appointment probably sometime tomorrow evening where we can go over the documents that you're providing.",
                "answerBy": "Symbl Tester 1",
                "answerTime": "00:00:54,240",
                "question": "Hey, when you will go to canada?",
                "questionBy": "Symbl Tester 2",
                "questionTime": "00:00:45,120"
            },
            {
                "answer": "I just need to discuss with my family in terms of which one will we go forward with it?",
                "answerBy": "Symbl Tester 2",
                "answerTime": "00:01:46,80",
                "question": "Why are you coming tomorrow ?",
                "questionBy": "Symbl Tester 1",
                "questionTime": "00:01:36,000"
            },
            {
                "answer": "It will be very helpful.",
                "answerBy": "Symbl Tester 1",
                "answerTime": "00:02:06,720",
                "question": "I have a quick question though. Is there basically website?",
                "questionBy": "Symbl Tester 2",
                "questionTime": "00:01:56,640"
            }
        ]
    },
    "callObjections": {
        "objections": [
            {
                "objection": "Is there basically website?",
                "objectionBy": "Symbl Tester 2",
                "objectionTime": "00:01:58,560",
                "response": "It will be very helpful.",
                "responseBy": "Symbl Tester 1",
                "responseTime": "00:02:06,720"
            }
        ]
    },
    "callNextSteps": {
        "nextSteps": [
            {
                "step": "John will send this by today.",
                "time": "00:00:40,800",
                "user": "Symbl Tester 2"
            },
            {
                "step": "I will come tomorrow.",
                "time": "00:00:52,320",
                "user": "Symbl Tester 1"
            },
            {
                "step": "I will set up a time and appointment probably sometime tomorrow evening where we can go over the documents that you're providing.",
                "time": "00:00:54,240",
                "user": "Symbl Tester 1"
            },
            {
                "step": "Tomorrow I will submit the documents.",
                "time": "00:01:07,200",
                "user": "Symbl Tester 1"
            },
            {
                "step": "I will ask them and see kind of the feedback I get and then I will get back with you tomorrow evening time.",
                "time": "00:04:34,80",
                "user": "Agent John"
            }
        ]
    },
    "createdOn": "2023-07-25T04:57:17.000Z",
    "updatedOn": "2023-07-25T04:57:17.000Z"
},
    {
        "conversationId": "4727267012902912",
        // "callStage": "qualification",
        "callScore": {
            "score": 75,
            "summary": "The representative performed well in some areas, such as communication and engagement, and question handling. However, there is room for improvement in forward motion and sales process.",
            "criteria": [
                {
                    "name": "Communication and Engagement",
                    "score": 80,
                    "summary": "The representative greeted the prospect at the beginning and end of the call, maintained a balanced talk time, and matched the prospect's pace. However, the agenda was not explicitly mentioned in the first 5 minutes, and there were a few interruptions.",
                    "feedback": {
                        "positive": {
                            "summary": "The representative greeted the prospect and maintained a balanced talk time."
                        },
                        "negative": {
                            "summary": "The agenda should be explicitly mentioned in the first 5 minutes, and interruptions should be minimized."
                        }
                    }
                },
                {
                    "name": "Question Handling",
                    "score": 85,
                    "summary": "The representative answered most of the prospect's questions and handled objections well.",
                    "feedback": {
                        "positive": {
                            "summary": "The representative answered questions and handled objections well."
                        },
                        "negative": {
                            "summary": "Ensure all questions are answered to provide the prospect with complete information."
                        }
                    }
                },
                {
                    "name": "Forward Motion",
                    "score": 60,
                    "summary": "The representative did not explicitly call out the next steps of the conversation and create alignment with the prospect.",
                    "feedback": {
                        "positive": {
                            "summary": ""
                        },
                        "negative": {
                            "summary": "The representative should explicitly call out the next steps and create alignment with the prospect."
                        }
                    }
                },
                {
                    "name": "Sales Process",
                    "score": 75,
                    "summary": "The representative asked questions regarding need and timeline but did not ask about budget, authority, or challenges in making a decision.",
                    "feedback": {
                        "positive": {
                            "summary": "The representative asked questions about need and timeline."
                        },
                        "negative": {
                            "summary": "The representative should also ask questions about budget, authority, and challenges in making a decision."
                        }
                    }
                }
            ]
        },
        "meetingName": "Product/Tech R&D Analysis",
        "prospectName": "Text API File LLC",
        "startTime": new Date().toISOString(),
        "duration": "0:38:20",
        "conversationType": "sales",
        "attendees": [
            {
                "email": "arshdeep@symbl.ai",
                "id": "b590e154-1215-48ac-8de2-6daae3926bb7",
                "name": "Arshdeep"
            },
            {
                "email": "surbhirathore@symbl.ai",
                "id": "99d2cb9a-7f17-4df4-920c-08e870484844",
                "name": "Surbhi"
            },
            {
                "email": "sharmistha@symbl.ai",
                "id": "eea24e9f-f2bb-41cd-8ae9-52b6ac0c2aca",
                "name": "Sharmistha"
            }
        ],
        "callSummary": {
            "executiveSummary": "The call transcript reveals Arshdeep discussing challenges faced while working with developers from other teams and the need to bridge the knowledge gap. Surbhi suggests organizing a hackathon to improve adoption and spread awareness. Vikram is assigned the task of planning the hackathon for immediate customers. Surbhi requests Vikram to summarize the conversation and send important action items. The call also touches on scheduling a follow-up discussion. Overall, the call focuses on addressing the gap between developers, planning a hackathon, and ensuring effective communication among team members.",
            "longSummary": {
                "bulletPoints": [
                    "Surbhi is unhappy with the support staff and wants a refund",
                    "Arshdeep is experiencing audio issues with his laptop",
                    "Vikram suggests restarting the call",
                    "Surbhi struggles to remember the updates for the last quarter",
                    "The company has achieved 75% revenue growth year-over-year",
                    "They are focusing on creating digital experiences for customers",
                    "The company is becoming a modern customer engagement platform",
                    "They are introducing conversation intelligence on every communication channel",
                    "There will be a big conference in the next quarter",
                    "The financial highlights include $295 million in total revenue for the third quarter",
                    "The company is targeting at least 80% increase in revenue for the next quarter",
                    "They are planning to expand employee count by 20%",
                    "They want to expand their presence in India, Philippines, China, and Japan",
                    "They want to track execution and progress on a weekly basis",
                    "They have seen consistent growth in brand recognition and NPS score",
                    "They are working on targeted account-based marketing initiatives",
                    "Arshdeep's qualitative feedback validates the high NPS scores",
                    "Customers are enjoying working with the company and see the value they provide",
                    "Arshdeep suggests hiring developer advocates to improve customer feedback",
                    "They want to create a direct point of contact for customers to reach out to",
                    "They are considering hiring part-time advocates across multiple cities",
                    "They want to learn from Enterprise customers' experience in driving internal use case evangelism",
                    "They are identifying advocates from their existing community to promote the product",
                    "They are looking for advocates who understand customer challenges and can provide valuable feedback",
                    "They are discussing the profile of advocates within enterprises and community drivers outside enterprises",
                    "They are considering focusing on hiring advocates as the first step to building advocacy",
                    "They plan to have a follow-up conversation with the product and technology team",
                    "They want to shift their focus to developer advocates and growing within their own circles",
                    "They are discussing hiring in specific geographies, with a focus on Europe",
                    "They have identified Ireland, specifically Cork, as a location with government support and talent",
                    "They are considering partnering with Cork Institute of Technology and a local community",
                    "They plan to hire remotely and interview candidates in Cork",
                    "They are participating in the Mobile World Conference and plan to set up hiring discussions",
                    "They are working on getting interviews lined up in the desired timeframe",
                    "They are discussing the need to connect with the general counsel and understand the space they are in",
                    "Arshdeep will work with Vikram to provide input on customers they can onboard",
                    "They are considering involving the general counsel in the meeting",
                    "They are discussing the need for input from Vikram and Arshdeep on understanding the space they are in",
                    "Arshdeep suggests organizing a hackathon to bridge the gap with customers",
                    "He proposes inviting individual developers to learn about their product",
                    "Surbhi emphasizes the need to focus on closing the gap with immediate customers",
                    "Vikram is tasked with creating a plan for the hackathon",
                    "They plan to have a follow-up discussion to review the conversation and important action items"
                ],
                "sentences": "Surbhi is unhappy with the support staff and wants a refund. Arshdeep is experiencing audio issues with his laptop. Vikram suggests restarting the call. Surbhi struggles to remember the updates for the last quarter. The company has achieved 75% revenue growth year-over-year. They are focusing on creating digital experiences for customers. The company is becoming a modern customer engagement platform. They are introducing conversation intelligence on every communication channel. There will be a big conference in the next quarter. The financial highlights include $295 million in total revenue for the third quarter. The company is targeting at least 80% increase in revenue for the next quarter. They are planning to expand employee count by 20%. They want to expand their presence in India, Philippines, China, and Japan. They want to track execution and progress on a weekly basis. They have seen consistent growth in brand recognition and NPS score. They are working on targeted account-based marketing initiatives. Arshdeep's qualitative feedback validates the high NPS scores. Customers are enjoying working with the company and see the value they provide. Arshdeep suggests hiring developer advocates to improve customer feedback. They want to create a direct point of contact for customers to reach out to. They are considering hiring part-time advocates across multiple cities. They want to learn from Enterprise customers' experience in driving internal use case evangelism. They are identifying advocates from their existing community to promote the product. They are looking for advocates who understand customer challenges and can provide valuable feedback. They are discussing the profile of advocates within enterprises and community drivers outside enterprises. They are considering focusing on hiring advocates as the first step to building advocacy. They plan to have a follow-up conversation with the product and technology team. They want to shift their focus to developer advocates and growing within their own circles. They are discussing hiring in specific geographies, with a focus on Europe. They have identified Ireland, specifically Cork, as a location with government support and talent. They are considering partnering with Cork Institute of Technology and a local community. They plan to hire remotely and interview candidates in Cork. They are participating in the Mobile World Conference and plan to set up hiring discussions. They are working on getting interviews lined up in the desired timeframe. They are discussing the need to connect with the general counsel and understand the space they are in. Arshdeep will work with Vikram to provide input on customers they can onboard. They are considering involving the general counsel in the meeting. They are discussing the need for input from Vikram and Arshdeep on understanding the space they are in. Arshdeep suggests organizing a hackathon to bridge the gap with customers. He proposes inviting individual developers to learn about their product. Surbhi emphasizes the need to focus on closing the gap with immediate customers. Vikram is tasked with creating a plan for the hackathon. They plan to have a follow-up discussion to review the conversation and important action items."
            },
            "mediumSummary": {
                "bulletPoints": [
                    "Surbhi expresses dissatisfaction with support staff and requests a refund",
                    "Arshdeep's audio issues cause interruptions",
                    "Vikram suggests restarting the call to resolve audio problems",
                    "Surbhi struggles to remember updates for the last quarter",
                    "Surbhi discusses the company's financial results",
                    "Total revenue for the third quarter was 295 million, a 75% increase from last year",
                    "Company aims for 80% revenue increase in the next quarter and employee expansion by 20%",
                    "Arshdeep proposes hiring developer advocates to improve customer feedback and support",
                    "Surbhi suggests considering full-time or part-time developer advocates and consulting with customers",
                    "Vikram explains the importance of identifying the right advocates and balancing feedback",
                    "Vikram suggests creating personas of advocates and consulting with enterprise customers",
                    "The goal is to understand challenges and gather balanced feedback for product improvement",
                    "Discussion on focusing sales hires in Europe and Asia-Pacific",
                    "Surbhi recommends hiring in Cork, Ireland due to government support and talent availability",
                    "Surbhi suggests partnering with Cork Institute of Technology and a local community",
                    "Vikram plans to participate in Mobile World Conference for recruitment opportunities",
                    "Plans for customer demos and interviews during the conference",
                    "Surbhi to introduce Vikram to the recruitment institute",
                    "Discussion on coordinating with the product and development teams for hiring positions",
                    "Surbhi asks if Arshdeep can provide input based on his experience with customers",
                    "Arshdeep mentions difficulties working with developers from the product team",
                    "Surbhi asks Vikram for suggestions on bridging the gap with customers",
                    "Arshdeep proposes a hackathon to engage developers and spread awareness about the product",
                    "Surbhi emphasizes the need to focus on closing the gap with immediate customers first",
                    "Discussion on scheduling a discussion about the hackathon",
                    "Surbhi requests Vikram to summarize the conversation and send important action items"
                ],
                "paragraphs": "Surbhi expresses her dissatisfaction with the support staff and requests a refund. Arshdeep's audio is not working properly throughout the call, causing interruptions. Vikram suggests restarting the call to resolve the audio issue. Surbhi struggles to remember the updates for the last quarter, but eventually discusses the company's financial results. Total revenue for the third quarter was 295 million, a 75% increase from last year. The company aims for an 80% revenue increase in the next quarter and an employee expansion of 20% to support new offerings. Arshdeep proposes hiring developer advocates to improve customer feedback and support. Surbhi suggests considering full-time or part-time developer advocates and consulting with customers. Vikram explains the importance of identifying the right advocates and balancing feedback. He suggests creating personas of advocates and consulting with enterprise customers to understand challenges and gather balanced feedback for product improvement. The discussion then shifts to focusing sales hires in Europe and Asia-Pacific. Surbhi recommends hiring in Cork, Ireland due to government support and talent availability. She suggests partnering with Cork Institute of Technology and a local community. Vikram plans to participate in Mobile World Conference for recruitment opportunities, including customer demos and interviews. Surbhi volunteers to introduce Vikram to the recruitment institute. They discuss coordinating with the product and development teams for hiring positions, and Surbhi asks if Arshdeep can provide input based on his experience with customers. Arshdeep mentions difficulties working with developers from the product team. Surbhi asks Vikram for suggestions on bridging the gap with customers. Arshdeep proposes a hackathon to engage developers and spread awareness about the product. Surbhi emphasizes the need to focus on closing the gap with immediate customers first. They discuss scheduling a discussion about the hackathon, and Surbhi requests Vikram to summarize the conversation and send important action items."
            },
            "smallSummary": {
                "bulletPoints": [
                    "Discussion on the need for developer advocates and strategies to gather customer feedback",
                    "Plans to set up a follow-up conversation with the product and technology team",
                    "Consideration of hiring in Europe, specifically in Ireland and Cork",
                    "Exploration of government support and R&D tax credits in Ireland",
                    "Ideas for organizing a hackathon to bridge the gap with customers and increase user adoption"
                ],
                "paragraphs": "During the call, there was a discussion about the need for developer advocates and strategies to gather customer feedback. Plans were made to set up a follow-up conversation with the product and technology team. The possibility of hiring in Europe, particularly in Ireland and Cork, was explored, with a focus on government support and R&D tax credits. Additionally, there were ideas discussed for organizing a hackathon to bridge the gap with customers and increase user adoption."
            }
        },
        "callSentiment": {
            "chunks": [
                {
                    "endTime": "00:02:00,000",
                    "polarityScore": "-0.6",
                    "sentiment": "Negative",
                    "startTime": "00:00:00,000",
                    "summary": "The call started with technical issues and a request for a refund."
                },
                {
                    "endTime": "00:04:00,000",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:02:00,000",
                    "summary": "Participants continued to troubleshoot audio issues and eventually resolved them."
                },
                {
                    "endTime": "00:06:00,000",
                    "polarityScore": "0.4",
                    "sentiment": "Positive",
                    "startTime": "00:04:00,000",
                    "summary": "The discussion shifted to company updates, including financial results, growth, and employee expansion."
                },
                {
                    "endTime": "00:08:00,000",
                    "polarityScore": "0.5",
                    "sentiment": "Positive",
                    "startTime": "00:06:00,000",
                    "summary": "The call continued with more details on financial results, employee growth, and plans for expansion in global markets."
                },
                {
                    "endTime": "00:10:00,000",
                    "polarityScore": "0.6",
                    "sentiment": "Positive",
                    "startTime": "00:08:00,000",
                    "summary": "The conversation focused on setting up processes to track progress on revenue targets and employee growth."
                },
                {
                    "endTime": "00:12:00,000",
                    "polarityScore": "0.7",
                    "sentiment": "Positive",
                    "startTime": "00:10:00,000",
                    "summary": "The call concluded with discussions on customer satisfaction, NPS scores, and plans for future growth."
                },
                {
                    "endTime": "00:16:00,202",
                    "polarityScore": "0.6",
                    "sentiment": "Positive",
                    "startTime": "00:14:43,31",
                    "summary": "Participants discussed positive customer feedback, high NPS scores, and challenges in product adoption."
                },
                {
                    "endTime": "00:18:00,000",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:16:00,202",
                    "summary": "The conversation continued with discussions on mitigating friction in customer experience and exploring the idea of developer advocacy."
                },
                {
                    "endTime": "00:20:00,000",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:18:00,000",
                    "summary": "Participants discussed strategies for hiring developer advocates and scaling the initiative for better customer engagement."
                },
                {
                    "endTime": "00:22:00,000",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:20:00,000",
                    "summary": "The call ended with discussions on identifying the right personas for developer advocates and understanding the challenges faced by enterprise customers."
                },
                {
                    "endTime": "00:24:03,870",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:22:41,770",
                    "summary": "Participants discussed the differences in personas for developer advocates within enterprises and community drivers outside of enterprises."
                },
                {
                    "endTime": "00:26:23,497",
                    "polarityScore": "0.5",
                    "sentiment": "Positive",
                    "startTime": "00:24:03,870",
                    "summary": "The conversation shifted to hiring in Europe, focusing on the benefits of setting up operations in Ireland and partnering with local institutions for talent acquisition."
                },
                {
                    "endTime": "00:28:17,240",
                    "polarityScore": "0.4",
                    "sentiment": "Positive",
                    "startTime": "00:26:23,497",
                    "summary": "Participants discussed the advantages of hiring in Cork, Ireland, due to the presence of Cork Institute of Technology and its AI and machine learning programs."
                },
                {
                    "endTime": "00:29:47,245",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:28:17,240",
                    "summary": "The call concluded with plans to work with the product and development teams to create a list of positions for hiring in Europe and exploring partnerships with local institutions."
                },
                {
                    "endTime": "00:36:44,191",
                    "polarityScore": "0",
                    "sentiment": "Neutral",
                    "startTime": "00:31:08,837",
                    "summary": "The conversation touched on working with customers, addressing gaps in technology knowledge, and organizing a hackathon for developers. Participants discussed the challenges of working with developers who have limited knowledge of the product and brainstormed ideas to bridge the gap, such as organizing a hackathon for developers to learn about the product and APIs."
                }
            ],
            "overallSentiment": "Neutral",
            "summary": "The call discussed technical issues, company updates, financial results, employee growth, future plans, strategies for developer advocacy, and hiring in Europe. Additionally, the conversation touched on working with customers, addressing gaps in technology knowledge, and organizing a hackathon for developers."
        },
        "callQuestionAndAnswers": {
            "questionAnswers": [
                {
                    "answer": "Okay, this is a problem with Arshdeep for sure.",
                    "answerBy": "Surbhi",
                    "answerTime": "00:00:44,705",
                    "question": "What could be the issue here?",
                    "questionBy": "Arshdeep",
                    "questionTime": "00:00:44,252"
                },
                {
                    "answer": "Yeah.",
                    "answerBy": "Sharmistha",
                    "answerTime": "00:03:32,100",
                    "question": "What do you mean like it's the name is flickering?",
                    "questionBy": "Arshdeep",
                    "questionTime": "00:03:29,781"
                },
                {
                    "answer": "Yeah, it's like note-taking is crazy.",
                    "answerBy": "Surbhi",
                    "answerTime": "00:05:21,299",
                    "question": "What am I supposed to pull out?",
                    "questionBy": "Surbhi",
                    "questionTime": "00:05:16,471"
                },
                {
                    "answer": "Yeah Vikram. I think that's the best idea.",
                    "answerBy": "Arshdeep",
                    "answerTime": "00:34:05,151",
                    "question": "So what is the best way to do like a gap analysis here?",
                    "questionBy": "Surbhi",
                    "questionTime": "00:15:07,72"
                },
                {
                    "answer": "Yeah, I mean, I am just trying to guess what do you say because you are breaking out a lot.",
                    "answerBy": "Surbhi",
                    "answerTime": "00:18:16,154",
                    "question": "What?",
                    "questionBy": "Sharmistha",
                    "questionTime": "00:33:04,309"
                },
                {
                    "answer": "So I think next quarter. We are targeting at least 80 percent increase in our Revenue targets.",
                    "answerBy": "Surbhi",
                    "answerTime": "00:08:05,678",
                    "question": "Yeah, so what are our next quarter goals?",
                    "questionBy": "Sharmistha",
                    "questionTime": "00:08:00,837"
                }
            ]
        },
        "callObjections": {
            "objections": [
                {
                    "objection": "I am unhappy with your support staff and want a refund.",
                    "objectionBy": "Surbhi",
                    "objectionTime": "00:00:26,171",
                    "response": "What could be the issue here?",
                    "responseBy": "Arshdeep",
                    "responseTime": "00:00:44,252"
                }
            ]
        },
        "callNextSteps": {
            "nextSteps": [
                {
                    "step": "Arshdeep should set up a follow-up conversation specifically with both the product and Technology team",
                    "time": "00:23:35,929",
                    "user": "Surbhi"
                },
                {
                    "step": "shift our focus more into our Dev, you know on the field of Advocates who can really help us grow with within their own circles",
                    "time": "00:24:13,228",
                    "user": "Arshdeep"
                },
                {
                    "step": "set up a discussion with product",
                    "time": "00:24:26,596",
                    "user": "Arshdeep"
                },
                {
                    "step": "understand how we can or in which geographies we need to focus on the sales hires first",
                    "time": "00:25:12,478",
                    "user": "Sharmistha"
                },
                {
                    "step": "schedule a discussion about hackathon idea",
                    "time": "00:35:58,993",
                    "user": "Arshdeep"
                },
                {
                    "step": "summarize all of this conversation and send it over with all the important stuff",
                    "time": "00:36:18,90",
                    "user": "Surbhi"
                }
            ]
        },
        "createdOn": "2023-07-25T06:18:27.000Z",
        "updatedOn": "2023-07-25T06:18:27.000Z"
    }
]